import { createSlice } from "@reduxjs/toolkit";

import { createSupportTicket, getSupportTickets } from "@/api/support/thunks";
import { SupportState } from "@/types/store";
import { Ticket } from "@/types/support";

const initialState: SupportState = {
  tickets: [],
  selectedTicket: null as Ticket | null,
  loading: false,
  loadingMore: false,
  hasNextPage: false,
  currentPage: 1,
  error: null,
};

export const supportSlice = createSlice({
  name: "SupportSlice",
  initialState,
  reducers: {
    clearSupportData: (state) => {
      Object.assign(state, initialState);
    },
    setSelectedTicket: (state, action) => {
      state.selectedTicket = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createSupportTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSupportTicket.fulfilled, (state, action) => {
      state.loading = false;
      state.tickets.unshift(action.payload);
    });
    builder.addCase(createSupportTicket.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
    builder.addCase(getSupportTickets.pending, (state) => {
      state.loading = state.currentPage === 1;
      state.loadingMore = state.currentPage > 1;
    });
    builder.addCase(getSupportTickets.fulfilled, (state, action) => {
      state.loading = false;
      state.loadingMore = false;

      const existingIds = new Set(
        state.tickets.map((ticket: Ticket) => ticket.id)
      );

      const newTickets = action.payload.supportTickets.filter(
        (ticket: Ticket) => !existingIds.has(ticket.id)
      );

      if (state.currentPage === 1) {
        state.tickets = action.payload.supportTickets;
      } else {
        state.tickets = [...state.tickets, ...newTickets];
      }

      state.hasNextPage = action.payload.hasNextPage ?? false;
    });
    builder.addCase(getSupportTickets.rejected, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = action.payload as string;
    });
  },
});

export const { clearSupportData, setCurrentPage, setSelectedTicket } =
  supportSlice.actions;

export default supportSlice.reducer;
